import React from 'react';
import { FiPrinter } from 'react-icons/fi';

import { Procedimento } from '@/models/Procedimento';

import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import { useEnterpriseContext } from '@/features/enterprise/contexts/EnterpriseContext';
import { clinicalDocumentPdf } from '@/features/pdf/documents/ClinicalDocumentLayout';
import DocumentPageEncaminhamento from '@/features/pdf/documents/DocumentPageEncaminhamento';
import IconButton from '../IconButton';

import { Container, Header, HeaderTitle, Actions } from './styles';

interface BoxEncaminhamentoProps {
  encaminhamento: Procedimento;
}

const BoxEncaminhamento: React.FC<BoxEncaminhamentoProps> = ({
  encaminhamento,
}) => {
  const [onHover, setOnHover] = React.useState(false);
  const [printing, setPrinting] = React.useState(false);

  const { user } = useAuth();
  const [{ encounter }] = useEnterpriseContext();

  const showImprimirButton = React.useMemo(() => {
    if (user?.empresa) {
      return !!user?.empresa?.features?.find(
        feature => feature.codigo === 'IMPRIMIR_ENCAMINHAMENTO',
      );
    }
    return true;
  }, [user]);

  const serviceRequest = React.useMemo<fhir4.ServiceRequest>(() => {
    const service: fhir4.ServiceRequest = {
      resourceType: 'ServiceRequest',
      status: 'active',
      intent: 'order',
      code: { text: encaminhamento.nome },
      subject: { reference: '' },
    };

    if (encaminhamento.descricao) {
      service.reasonCode = [{ text: encaminhamento.descricao }];
    }

    return service;
  }, [encaminhamento.nome, encaminhamento.descricao]);

  const titulo = React.useMemo(() => {
    return (
      serviceRequest.code?.text ||
      serviceRequest.code?.coding?.[0]?.display ||
      encaminhamento.nome
    );
  }, [serviceRequest, encaminhamento.nome]);

  const imprimirEncaminhamento = React.useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      try {
        setPrinting(true);
        await clinicalDocumentPdf(DocumentPageEncaminhamento, {
          user,
          resource: serviceRequest,
          encounter: encounter.data,
        });
      } catch (error) {
        throw new Error(`Erro ao gerar PDF do encaminhamento: ${error}`);
      } finally {
        setPrinting(false);
      }
    },
    [user, serviceRequest, encounter.data],
  );

  return (
    <Container>
      <Header>
        <HeaderTitle highlight={onHover}>{titulo}</HeaderTitle>

        <Actions>
          {showImprimirButton && (
            <IconButton
              disabled={printing}
              tooltip="Imprimir"
              onClick={imprimirEncaminhamento}
              onMouseOver={() => setOnHover(true)}
              onMouseLeave={() => setOnHover(false)}
              icon={<FiPrinter />}
            />
          )}
        </Actions>
      </Header>
    </Container>
  );
};

export default BoxEncaminhamento;
